import type { ReactNode } from 'react';
import InfoIcon from '@/shared/assets/info-icon.svg?react';

type InfoCardProps = {
  title?: string;
  children?: ReactNode;
};

export function InfoCard({ title, children }: InfoCardProps) {
  return (
    <div className="flex flex-col gap-[0.8rem] bg-card text-card-foreground flex flex-col gap-6 rounded-4xl px-[1.6rem] py-[1.2rem] shadow-sm text-secondary">
      <div className="flex items-start gap-[1rem]">
        <div className="flex items-center justify-center">
          <InfoIcon className="size-[2.4rem]" />
        </div>
        {title && <div className="headline5 self-center">{title}</div>}
      </div>
      <div className="p4 text-muted-foreground">{children}</div>
    </div>
  );
}
